const flagSource = window["featureFlags"] || {};
const current = Object.keys(flagSource);

// Primitives
type toggled = boolean; // check if flag is being used/unused
type PWDC = number; // Preferred identifier
type StringNoSpaces = string; // make sure not to add spaces

// Flag Entries
type Flag = PWDC | StringNoSpaces;
type CurrentFlags = Flag[]; //
type FlagEntry = [Flag, toggled];
type FlagEntries = FlagEntry[];

// Service
interface Service {
	current: CurrentFlags;
	setupEntries: () => FlagEntries;
}

const featureFlags: Service = {
	current,
	setupEntries: (): FlagEntries => {
		return current.map((name) => [name, flagSource[name]]);
	},
};

export default featureFlags;
